import { createSlice } from '@reduxjs/toolkit';
import { ADDRESS_TYPES } from '../../utilities/constants';
import { CLIENT_ADDRESS_SCHEMA, CLIENT_RESERVATION_SCHEMA, CLIENT_TAX_SCHEMA } from '../../utilities/objectSchemas';

const initialState = {
    originalReservation: null,
    clientReservation: CLIENT_RESERVATION_SCHEMA,
};

export const reservationSlice = createSlice({
    name: 'reservation',
    initialState,
    reducers: {
        resetReservation: () => initialState,
        setReservation: (state, { payload } ) => {
            state.originalReservation = {
                ...payload,
                currencyInfo: {
                    currencyId: payload?.currencyId ?? 1,
                    currencyCode: payload.currency,
                    currencyExchange: payload.currencyExchange
                }
            };
            state.clientReservation = {
                ...payload.reservationClient,
                address: {
                    ...CLIENT_ADDRESS_SCHEMA,
                    ...(payload.reservationClient?.address ?? CLIENT_ADDRESS_SCHEMA),
                    clientAddressTypeId: payload.reservationClient.address?.clientAddressType?.id ?? ""
                },
                taxData: {
                    ...CLIENT_TAX_SCHEMA,
                    ...payload.reservationClient?.taxData,
                },
            };
        },
        setClientAddressReservation: (state, { payload }) => {
            state.clientReservation.address = {
                addressId: state.clientReservation.address.addressId,
                clientAddressType: ADDRESS_TYPES.find(x => x.id == payload.clientAddressTypeId),
                clientAddressTypeId: ADDRESS_TYPES.find(x => x.id == payload.clientAddressTypeId).id,
                street: payload.street,
                street2: payload.street2,
                zipCode: payload.zipCode,
                city: payload.city,
                state: payload.state,
                countryId: payload.countryId,
            }
        },
        setClientTaxReservation: (state, { payload }) => {
            state.clientReservation.taxData = {
                rfc: payload.rfc.toUpperCase(),
                clientType: payload.clientType,
                taxRegimeId: payload.taxRegimeId,
                razonSocial: payload.razonSocial,
                codigoPostal: payload.codigoPostal,
                invoiceRequired: true,
            }
        },
        setEmailClient: (state, { payload }) => {
            state.clientReservation.email = payload;
        },
        setPhoneClient: (state, { payload }) => {
            state.clientReservation.phone = payload;
        },
        setRequireInvoice: (state, { payload }) => {
            state.clientReservation.taxData.invoiceRequired = payload;
        }
    }
});


// Action creators are generated for each case reducer function
export const { resetReservation, setReservation, setClientAddressReservation, setClientTaxReservation, setEmailClient, setPhoneClient, setRequireInvoice } = reservationSlice.actions;
